import React, {useState} from 'react';
import styles from '@/styles/home.module.css';
import {useNavigate} from "react-router-dom";

const CertificateSearch: React.FC = () => {
    const [name, setName] = useState('');
    const [codeNumber, setCodeNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    const handleSearch = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!name.trim() || !codeNumber.trim()) {
            setError('姓名和证书编号必须输入才可查询');
            return;
        }

        try {
            setLoading(true);
            setError(null);

            // Navigate to certificate result page with query parameters
            navigate(`/certificateResult?name=${encodeURIComponent(name.trim())}&codeNumber=${encodeURIComponent(codeNumber.trim())}`);
        } catch (error) {
            console.error('Error during navigation:', error);
            setError('查询出错，请稍后再试');
            setLoading(false);
        }
    };

    return (
        <div className={`${styles.xz_col} ${styles.h360}`}>
            <div className={styles.col_title}>
                <div>
                    <div>证书查询</div>
                </div>
            </div>
            <div className={styles.col_con}>
                <div className={styles.cx}>
                    <form onSubmit={handleSearch}>
                        <div className={styles.row}>
                            <div className={styles.col_25}>
                                <label htmlFor="name">姓名</label>
                            </div>
                            <div className={styles.col_75}>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="请输入姓名"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    disabled={loading}
                                />
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.col_25}>
                                <label htmlFor="idcard">证书编号</label>
                            </div>
                            <div className={styles.col_75}>
                                <input
                                    type="text"
                                    id="idcard"
                                    name="idcard"
                                    placeholder="请输入证书编号"
                                    value={codeNumber}
                                    onChange={(e) => setCodeNumber(e.target.value)}
                                    disabled={loading}
                                />
                            </div>
                        </div>
                        <div>
                            <input
                                type="submit"
                                value={loading ? "查询中..." : "查询"}
                                disabled={loading}
                            />
                        </div>
                        {error && (
                            <div className={styles.cx_error} style={{color: 'red', marginTop: '10px'}}>
                                {error}
                            </div>
                        )}

                        <div className={styles.cx_tips}>
                            <span>提示：</span>姓名和证书编号必须输入才可查询
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CertificateSearch; 